import { render, staticRenderFns } from "./AICartoon_Banner_1.vue?vue&type=template&id=fed3af64&scoped=true"
import script from "./AICartoon_Banner_1.vue?vue&type=script&lang=js"
export * from "./AICartoon_Banner_1.vue?vue&type=script&lang=js"
import style0 from "./AICartoon_Banner_1.vue?vue&type=style&index=0&id=fed3af64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed3af64",
  null
  
)

export default component.exports